package com.pincer.core.rules

import com.pincer.core.InvalidData
import com.pincer.core.model.tree.Candidate

class DurationFromToRule(val from: Int, val to: Int): Rule() {

    override fun score(candidate: Candidate): Float {
        val duration = candidate.duration() ?: return MIGHT_BE_POSSIBLE
        if (duration >= from && duration <= to) return DEFINITELY_POSSIBLE
        return DEFINITELY_NOT_POSSIBLE
    }

    companion object {
        fun parse(params: List<String>): DurationFromToRule {
            if (params.size != 2) throw InvalidData("The durationFromToRule needs exactly two numbers")
            try {
                val build = DurationFromToRule(params.get(0).toInt(), params.get(1).toInt())
                if (build.from < 1) throw InvalidData("On the durationFromToRule, 'from' needs to be greater than 0 ")
                if (build.to < build.from) throw InvalidData("On the durationFromToRule, 'to' needs to be greater than 'from'")
                return build
            }
            catch (nfe: NumberFormatException) { throw InvalidData("One of the numbers in the durationFromToRule looks wrong") }
        }
    }

}
